import React from "react";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Box from "@mui/material/Box";
import Config from "conFig.js";
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const gpcolumn = [
  {
    field: "tendonvi",
    headerName: "Đơn vị",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "diachidonvi",
    headerName: "Địa chỉ",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "sodienthoai",
    headerName: "Số điện thoại",
    width: 120,
    headerAlign: "center",
  },
  {
    field: "sogiayphep",
    headerName: "Số giấy phép",
    width: 170,
    headerAlign: "center",
  },
  {
    field: "giayphepdkkd",
    headerName: "Giấy phép ĐKKD",
    width: 170,
    headerAlign: "center",
  },
  {
    field: "ngaycapgpdkkd",
    headerName: "Ngày cấp GPĐKKD",
    width: 170,
    headerAlign: "center",
  },
  {
    field: "ngaycapgpkdvt",
    headerName: "Ngày cấp GPKDVT",
    width: 170,
    headerAlign: "center",
  },
  {
    field: "ngayhethangpkdvt",
    headerName: "Ngày hết hạn GPDKVT",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "nguoidaidien",
    headerName: "Người đại diện",
    width: 170,
    headerAlign: "center",
  },
  {
    field: "nguoidieuhanh",
    headerName: "Người điều hành",
    width: 170,
    headerAlign: "center",
  },
];

export default function Hethangiayphepkinhdoanh() {
  const [pageSize, setPageSize] = React.useState(50);
  const [giayphep, setGiayphep] = React.useState([]);
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getcanhbaohangpkd = () => {
    var url =
      Config.backend + "/api/canhbao/canhbaohethangpdkkd?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setGiayphep(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  React.useEffect(() => {
    getcanhbaohangpkd();
  }, []);
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12}>
        <div style={{ height: 500, width: "100%", marginTop: 10 }}>
          <DataGrid
            getRowId={(row) => row.id}
            rows={giayphep}
            columns={gpcolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
    </GridContainer>
  );
}
